import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import { dateFormat } from 'src/helpers/date_helper';
import {
	featureIconMap,
	featureColorMap,
	type ReleaseFeature,
	type ReleaseVersion,
} from 'src/types/Changelog';

const buildFeatureLabels = (feature: ReleaseFeature) => {
	const formatFn = get(format);
	const color = featureColorMap[feature.type] ?? featureColorMap.default;

	const labels = [
		{
			icon: featureIconMap[feature.type] || featureIconMap.default,
			iconColor: `--color-${color}`,
			type: `${color}-10`,
			size: 's',
			value: formatFn(feature.type).toUpperCase(),
			textClass: `text-${color} miniature-styles`,
			class: 'ml-s',
		},
	];

	if (feature.premium) {
		labels.push({
			icon: 'fa-solid fa-gem icon-premium-color',
			iconColor: `--color-${color}`,
			type: 'premium-10',
			size: 's',
			value: formatFn('label_premium', { default: 'PREMIUM' }).toUpperCase(),
			textClass: 'icon-premium-color',
			class: 'ml-s',
		});
	}

	if (feature.experimental) {
		labels.push({
			icon: 'fa-solid fa-vial',
			iconColor: `--color-${color}`,
			type: 'experimental',
			size: 's',
			value: formatFn('label_shelly_labs', { default: 'SHELLY LABS' }).toUpperCase(),
			textClass: 'text-primary',
			class: 'ml-s',
		});
	}

	return labels;
};

export const buildVersionSection = (version: ReleaseVersion) => {
	const formatFn = get(format);
	const date = dateFormat(new Date(version.timestamp * 1000), 'd M, Y');

	return {
		id: `version-${version.appVersion}`,
		title: `${formatFn('title_app_version', { default: 'App version' })} ${version.appVersion} (${date})`,
		subtitles: version.features.map((feature) => ({
			title: feature.title,
			labels: buildFeatureLabels(feature),
			description: feature.description ? [feature.description] : [],
		})),
	};
};
